export const billingInvoicesListHandler = {
    pathPattern: '/brands/:brandId/billing/invoices',
    toWeb: ({ brandId }) => ({ path: `/brands/${brandId}/billing/invoices` }),
    meta: {
        title: 'Billing invoices',
        description: 'Opens the brand billing invoices list in the dashboard.',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [{ name: 'brandId', in: 'path', required: true }],
        example: { params: { brandId: 'BXqExampleBrandId' } },
    },
};
//# sourceMappingURL=billing-invoices-list.js.map